import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Course, Unit } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import unitComparisonViewAction from "cc-frontend/lib/actions/course/calendar/UNIT_COMPARISON_VIEW"
import type Dispatcher from "cc-frontend/services/dispatcher"
import type ModalManager from "cc-frontend/services/modal-manager"
import styles from "./units-in-header.module.css"
interface Sig {
  Args: {
    planbook: Planbook
    course: Course
    rotationCalendar: RotationCalendar
    dateString: string
    editCourseTitleAndOrder: Function
    units: Array<Unit>
  }
}

export default class UnitsInHeader extends Component<Sig> {
  readonly styles = styles
  @service modalManager!: ModalManager
  @service declare dispatcher: Dispatcher

  @action
  viewUnit(unitId) {
    // The legacy planner never compares across courses: the unit and the lesson are the same
    // course's, so both sides of the modal get the same models.
    const models = {
      planbook: this.args.planbook,
      course: this.args.course,
      rotationCalendar: this.args.rotationCalendar,
      editCourseTitleAndOrder: this.args.editCourseTitleAndOrder,
    }
    this.modalManager.openModal("planner/modals/unit-comparison-modal", {
      unit: { ...models, unitId: unitId },
      lesson: { ...models, dateString: this.args.dateString },
    })
    this.dispatcher.dispatchPreparedAction(
      unitComparisonViewAction({
        unitId: unitId,
        course: this.args.course,
        planbook: this.args.planbook,
      })
    )
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::CardStacks::Lesson::UnitsInHeader": typeof UnitsInHeader
  }
}
